/**
 * Track discount-code attempts in the cart drawer.
 * Intercepts /cart/update.js calls that include a "discount" field
 * and pipes a discount_attempt event through window.trackEvent so it
 * lands in Rainbow Track like any other event.
 *
 * Loaded after rb-track.js in theme.liquid.
 */
(function () {
  if (window.__rbDiscountTrack) return;
  window.__rbDiscountTrack = true;

  var originalFetch = window.fetch.bind(window);
  if (!originalFetch) return;

  // Track recent attempts per session to flag "code hammering".
  var sessionAttempts = [];

  function emit(payload) {
    try {
      if (typeof window.trackEvent === "function") {
        window.trackEvent(payload);
      }
    } catch (e) { /* swallow */ }
  }

  function parseBody(body) {
    if (!body) return null;
    if (typeof body === "string") {
      try { return JSON.parse(body); } catch (e) { return null; }
    }
    if (body instanceof FormData) {
      var o = {};
      body.forEach(function (v, k) { o[k] = v; });
      return o;
    }
    return null;
  }

  function attemptedCodesFromPayload(payload) {
    if (!payload) return [];
    var raw = payload.discount;
    if (raw == null) return [];
    if (Array.isArray(raw)) return raw.filter(Boolean);
    return String(raw).split(",").map(function (s) { return s.trim(); }).filter(Boolean);
  }

  // True if the current browser is a TikTok or Instagram in-app webview.
  // Pattern based on user-agent fingerprints those apps leave when they
  // open external URLs inside their embedded browser.
  function isInAppRestrictedBrowser() {
    var ua = (navigator.userAgent || "").toLowerCase();
    return /\b(instagram|fbav|fban|fb_iab|fbios|musical_ly|bytedance|tiktok|trill)\b/.test(ua);
  }

  // Personalized influencer codes: ban them inside TikTok/IG in-app browsers
  // so they aren't burned on traffic that's already commission-attributable.
  // Pattern catches "AliceRainbow26", "VeronicaRainbow26", "Viky20", "Francy35", etc.
  var PERSONAL_CODE_PATTERNS = [
    /^[A-Za-z]{3,}rainbow\d{2,}$/i,
    /^[A-Za-z]{3,}\d{2,3}$/, // short personal handles like Viky20
  ];
  // Codici promo PUBBLICI (inserzioni Meta/Google, tool ciondolo, carrello):
  // non sono codici influencer e devono funzionare anche dentro Instagram,
  // Facebook e TikTok, da dove arriva il traffico pubblicitario. Senza questa
  // lista HOLA10 veniva preso dal pattern "parola+cifre" e bloccato in-app.
  var PUBLIC_CODES = /^(HOLA|HOLA10|HISTORIA10|HALLOWEEN|HLWG26|WELCOME|6X4|3X2)$/i;
  function isPersonalCode(code) {
    var c = String(code || "").trim();
    if (PUBLIC_CODES.test(c)) return false;
    return PERSONAL_CODE_PATTERNS.some(function (p) { return p.test(c); });
  }

  function showBlockedToast(code) {
    try {
      var existing = document.getElementById("rb-discount-block-toast");
      if (existing) existing.remove();
      var el = document.createElement("div");
      el.id = "rb-discount-block-toast";
      el.style.cssText = "position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);background:#3A2A20;color:#F5F0EB;padding:18px 22px;border-radius:14px;max-width:320px;text-align:center;font:14px/1.45 -apple-system,Segoe UI,sans-serif;z-index:99999;box-shadow:0 12px 40px rgba(0,0,0,0.3);";
      el.innerHTML = "Il codice <strong>" + code + "</strong> non è valido in questo browser.<br><br>Apri il sito su Chrome o Safari per usarlo.";
      document.body.appendChild(el);
      setTimeout(function () { if (el.parentNode) el.remove(); }, 6000);
    } catch (e) { /* swallow */ }
  }

  // Codici che corrispondono a uno sconto GIA attivo in automatico sul carrello:
  // se il cliente li digita non serve, e non deve vedere un errore rosso ma un
  // messaggio verde rassicurante.
  var AUTO_CODES = /^(6x4|3x2)$/i;
  function isAutoCode(code) { return AUTO_CODES.test(String(code || "").trim()); }
  function showGreenToast(code) {
    try {
      var ex = document.getElementById("rb-green-toast"); if (ex) ex.remove();
      var el = document.createElement("div");
      el.id = "rb-green-toast";
      el.style.cssText = "position:fixed;left:50%;bottom:26px;transform:translateX(-50%);background:#1E7A46;color:#fff;padding:14px 20px;border-radius:12px;max-width:360px;text-align:center;font:600 14px/1.45 -apple-system,Segoe UI,sans-serif;z-index:2147483000;box-shadow:0 10px 34px rgba(0,0,0,0.24);display:flex;align-items:center;gap:10px;justify-content:center;";
      el.innerHTML = "<span style=\"font-size:18px;line-height:1\">✓</span><span>Sconto già applicato! Il <strong>" + String(code).toUpperCase() + "</strong> si attiva da solo sul carrello, non serve inserirlo.</span>";
      document.body.appendChild(el);
      setTimeout(function () { if (el.parentNode) { el.style.transition = "opacity .4s"; el.style.opacity = "0"; setTimeout(function () { el.remove(); }, 400); } }, 5000);
    } catch (e) { /* swallow */ }
  }

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var isCartUpdate = /\/cart\/update\.js/i.test(url);
    var attemptedCodes = [];
    if (isCartUpdate) {
      var bodyText = init && init.body;
      var payload = parseBody(bodyText);
      attemptedCodes = attemptedCodesFromPayload(payload);
    }

    // Block personalized influencer codes in TikTok/Instagram in-app webview.
    // Emit a tracking event for analytics and short-circuit the fetch with
    // a synthetic 422 so the cart doesn't apply the discount.
    if (isCartUpdate && attemptedCodes.length > 0 && isInAppRestrictedBrowser()) {
      var blocked = attemptedCodes.filter(isPersonalCode);
      if (blocked.length > 0) {
        blocked.forEach(function (code) {
          emit({
            event: "discount_attempt",
            discount_code: code,
            discount_result: "blocked_inapp_browser",
            attempts_in_session: 0,
            hammering: false,
          });
        });
        showBlockedToast(blocked[0]);
        return Promise.resolve(new Response(
          JSON.stringify({ status: 422, message: "Discount not available in this browser", description: "Codice non utilizzabile in questo browser. Apri su Chrome o Safari." }),
          { status: 422, headers: { "Content-Type": "application/json" } }
        ));
      }
    }

    var p = originalFetch(input, init);
    if (!isCartUpdate || attemptedCodes.length === 0) return p;

    return p.then(function (response) {
      // Clone so the original consumer can still read the body
      var clone = response.clone();
      return clone.json().then(function (j) {
        var applicable = {};
        if (j && Array.isArray(j.discount_codes)) {
          j.discount_codes.forEach(function (c) {
            if (c && c.code) applicable[c.code.toLowerCase()] = !!c.applicable;
          });
        }
        attemptedCodes.forEach(function (code) {
          var lc = code.toLowerCase();
          // applicable map missing means Shopify silently dropped it = invalid
          var result = (lc in applicable) ? (applicable[lc] ? "success" : "invalid") : "invalid";
          sessionAttempts.push({ code: lc, result: result, ts: Date.now() });
          // hammering = >=3 attempts in 60s
          var sixtyAgo = Date.now() - 60_000;
          var recent = sessionAttempts.filter(function (a) { return a.ts >= sixtyAgo; });
          var hammering = recent.length >= 3;
          emit({
            event: "discount_attempt",
            ecommerce: {
              currency: (j && j.currency) || "EUR",
              value: (j && typeof j.total_price === "number") ? j.total_price / 100 : null,
            },
            discount_code: code,
            discount_result: result,
            attempts_in_session: recent.length,
            hammering: hammering,
          });
        });
        // Sconti gia automatici (6X4/3X2): niente errore rosso. Tolgo il codice non
        // valido dalla risposta (cosi il tema non mostra l'errore) e mostro un toast verde.
        var autoHit = attemptedCodes.filter(isAutoCode);
        if (autoHit.length > 0 && j && Array.isArray(j.discount_codes)) {
          var before = j.discount_codes.length;
          j.discount_codes = j.discount_codes.filter(function (c) {
            return !(c && c.code && isAutoCode(c.code) && !c.applicable);
          });
          if (j.discount_codes.length < before) {
            showGreenToast(autoHit[0]);
            return new Response(JSON.stringify(j), { status: response.status, statusText: response.statusText, headers: { "Content-Type": "application/json" } });
          }
        }
        return response;
      }).catch(function () { return response; });
    }).catch(function (err) {
      attemptedCodes.forEach(function (code) {
        emit({
          event: "discount_attempt",
          discount_code: code,
          discount_result: "network_error",
          attempts_in_session: 0,
          hammering: false,
        });
      });
      throw err;
    });
  };
})();
